import { gql } from '@apollo/client';

import {
  interactiveLessonSectionFragment,
  interactiveLessonSectionOverviewFragment,
} from 'approot/activity-builder/lesson-builder.graphql';
import { interactiveContentStyleBackgroundFragment } from '../styles/styles.graphql';

export const GET_DRAFT_CONTENT_DRAFT = gql`
  query GetDraftContent($input: GetDraftContentInput!) {
    getDraftContent(input: $input) {
      ... on LessonActivities {
        id
        language
        version
        date
        focusQuestion {
          value
        }
        phenomena {
          value
        }
        landscapeImage {
          key
          fileName
          original
          alt
          data {
            flip
          }
          responsive {
            width
            height
            urls {
              url
              quality
            }
          }
        }
        landscapeImageSourceUrl
        styles {
          fontSize
          ...InteractiveContentStyleBackground
        }
        lesson {
          authorId
          slug
          name
          years {
            name
          }
          unit {
            id
            name
          }
          subjects {
            id
            label
            colour
          }
          landscapeImage {
            responsive {
              width
              height
              urls {
                url
                quality
              }
            }
          }
        }
        sectionsOverview {
          ...InteractiveLessonSectionOverview
        }
        status
        version
        hasUnpublishedChanges
        downloadUrl
        printPdfKey
        printPdfKeyPublicToken
        studentPrintables {
          downloadUrl
          previewUrl
        }
        assetKeys {
          print {
            language
            key
            publicToken
          }
          studentPrintables {
            language
            key
            publicToken
          }
        }
        assetDownloadUrls {
          language
          url
        }
        availableTranslations
      }
      ... on AssessmentActivities {
        id
        language
        date
        landscapeImage {
          key
          fileName
          original
          alt
          data {
            flip
          }
          responsive {
            width
            height
            urls {
              url
              quality
            }
          }
        }
        landscapeImageSourceUrl
        styles {
          fontSize
          ...InteractiveContentStyleBackground
        }
        assessment {
          authorId
          slug
          name
          years {
            name
          }
          unit {
            id
            name
          }
          subjects {
            id
            label
            colour
          }
          landscapeImage {
            responsive {
              width
              height
              urls {
                url
                quality
              }
            }
          }
        }
        sectionsOverview {
          ...InteractiveLessonSectionOverview
        }
        status
        version
        hasUnpublishedChanges
        downloadUrl
        printPdfKey
        studentPrintables {
          downloadUrl
          previewUrl
        }
        assessmentName
        assetKeys {
          print {
            language
            key
            publicToken
          }
          studentPrintables {
            language
            key
            publicToken
          }
        }
        assetDownloadUrls {
          language
          url
        }
        availableTranslations
      }
    }
  }
  ${interactiveLessonSectionOverviewFragment}
  ${interactiveContentStyleBackgroundFragment}
`;

export const GET_DRAFT_CONTENT_SECTIONS = gql`
  query GetDraftContentSections($input: GetDraftContentSectionsInput!) {
    getDraftContentSections(input: $input) {
      ...InteractiveLessonSectionFragment
    }
  }
  ${interactiveLessonSectionFragment}
`;

export const RESTORE_DRAFT_CONTENT = gql`
  mutation RestoreDraftContent($input: RestoreDraftContentInput!) {
    restoreDraftContent(input: $input) {
      ... on AssessmentActivities {
        id
        language
      }
      ... on LessonActivities {
        id
        language
      }
    }
  }
`;
